import {PolIcon} from "components/PolIcon/policon";
import React, {useEffect} from "react";
import {QUOTE_PRODUCTS_FILES} from "v4/data/apiRoutes";
import './ImportProductsDocsButtons.scss';
import useFetch from "v4/hooks/useFetch";
import useNotification from "v4/hooks/useNotification";
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import {generateUrl} from "v4/services/api.service";

export default function ImportProductsDocsButtons({quoteId, filePondRef}) {
    const {t} = usePolTranslation()
    const [{data, isLoading, isFinished, isError}, fetchDocuments] = useFetch()
    const {addErrorNotification} = useNotification()

    const handleImportProductsFiles = () => {
        fetchDocuments({
            url: generateUrl(QUOTE_PRODUCTS_FILES, {id: quoteId}),
        })
    }

    const processFile = async (file) => {
        const response = await fetch(file.source);
        const blob = await response.blob();

        return new File(
            [blob],
            file.name,
            {type: file.type},
        )
    }

    useEffect(() => {
        if (data?.files?.length && isFinished && !isError) {
            Promise.all(data.files.map(processFile))
                .then(processedFiles => {
                    filePondRef.current.addFiles(processedFiles);
                })
        }

        if (isError) {
            addErrorNotification(t('error_occured_while_loading_products_files'))
        }
    }, [data, isLoading, isFinished, isError, filePondRef, addErrorNotification, t])

    return (
        <button type="button"
                onClick={handleImportProductsFiles}
                disabled={isLoading}
                className="btn btn-primary import-files-button">
            {!isLoading &&
                (t('add_products_quote_files'))
            }
            {isLoading &&
                (<>{t('processing_products_files')} <PolIcon icon="circle-notch spin"/></>)
            }
        </button>
    )
}
